import { render, staticRenderFns } from "./MerchantFooter.vue?vue&type=template&id=e5e6440e&scoped=true"
import script from "./MerchantFooter.vue?vue&type=script&lang=js"
export * from "./MerchantFooter.vue?vue&type=script&lang=js"
import style0 from "./MerchantFooter.vue?vue&type=style&index=0&id=e5e6440e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e6440e",
  null
  
)

export default component.exports